import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Device identifiers captured at checkout for Visa Compelling Evidence 3.0.
//
// CE3.0 lets a prior undisputed transaction shift liability only when it shares at
// least two matching elements with the disputed one, and the two device elements are
// among the five available. What makes this hard is the window: a prior can be up to
// 365 days old, so the value has to still match a year later.
//
// No single identifier survives that reliably, and the ways they fail do not overlap:
//
//   kick_did        cookie we set   -- lost when cookies are cleared
//   __stripe_mid    Stripe's cookie -- lost the same way, but blocked/kept separately
//   FingerprintJS   computed hash   -- survives a cookie clear, drifts when the
//                                      browser or OS updates
//
// So all three are captured and stored per order, and which one is actually submitted
// is decided when a dispute arrives, from whichever still matches the priors. See
// resolveCE3DeviceElements in app/service/dispute_evidence.go.
//
// Only the computed fingerprint is sent from here. kick_did is HttpOnly and
// __stripe_mid is a first-party cookie, so both reach the server on their own -- and a
// value the browser hands us could be anything, which matters for something submitted
// as evidence.

// Loaded lazily, and only from the payment step. Canvas, audio and WebGL probing
// across the intake questionnaire is a materially different privacy posture for a
// telehealth site, and the transaction CE3.0 cares about happens here.
export async function computeDeviceFingerprint() {
  try {
    const agent = await FingerprintJS.load();
    const { visitorId } = await agent.get();
    return visitorId || "";
  } catch (error) {
    // Blocked by an extension, or an API this browser does not expose. The other two
    // identifiers still stand; an empty value simply drops out of the selection.
    console.warn("[deviceFingerprint] unavailable", error);
    return "";
  }
}
